import { Font } from '@react-pdf/renderer';
import TaipeiSansTCBeta from './assets/fonts/TaipeiSansTCBeta-Regular.ttf';

Font.register({
  family: 'TaipeiSansTCBeta',
  src: TaipeiSansTCBeta,
});

Font.registerHyphenationCallback((word: string) => [word]);
